module.exports = __webpack_public_path__ + "img/img_1.2541a7c4.jpg";